import React from 'react'
import Select from '../../../common/select/Select'
import { i18n } from '../../index'
import css from '../customerSales/customerSales.css'

export type ProductType =
  | 'Buffet'
  | 'Sweet'
  | 'Salty'
  | 'ALaCarte'
  | 'Pizzatable'
  | 'ABCPizza'
  | 'ABCBurger'
  | 'PikaCarte'
  | 'Arnolds'
  | 'BuffetWorld'

const PRODUCT_TYPES = ['Buffet', 'Sweet', 'Salty', 'ALaCarte', 'PikaCarte']

const ADDITIONAL_PRODUCT_TYPES = ['AbcPizzaTable', 'ABCPizza', 'ABCBurger', 'Arnolds', 'AbcBuffetWorld']

const ADDITIONAL_PRODUCT_NAME_TO_SETTING_NAME = {
  AbcPizzaTable: 'Pizzatable',
  ABCPizza: 'ABCPizza',
  ABCBurger: 'ABCBurger',
  Arnolds: 'Arnolds',
  AbcBuffetWorld: 'BuffetWorld',
}

export const DEFAULT_PRODUCT_TYPE: ProductType = 'Buffet'

function getDisplayedProductTypes(settings: { name: string }[]): string[] {
  const settingNames = settings.map((setting) => setting.name)
  const productTypesToAdd = ADDITIONAL_PRODUCT_TYPES.filter((name) =>
    settingNames.includes(ADDITIONAL_PRODUCT_NAME_TO_SETTING_NAME[name]),
  )
  return PRODUCT_TYPES.concat(productTypesToAdd)
}

interface Props {
  onChange: (option: string) => void
  stationSettings?: { name: string }[] | null
  value: string
  overridePizzaTable?: boolean
}

export default function ProductTypeSelector({ onChange, stationSettings, value, overridePizzaTable = false }: Props) {
  return (
    <Select
      className={css.typeSelect}
      options={
        stationSettings
          ? getDisplayedProductTypes(stationSettings).map((productType) =>
              overridePizzaTable && productType === 'AbcPizzaTable' ? 'Pizzatable' : productType,
            )
          : PRODUCT_TYPES
      }
      getOptionLabel={(option) => i18n.t(`reporting.${option.value.toLowerCase()}`)}
      value={value}
      onChange={onChange}
    />
  )
}
